import { computed, ComputedRef } from 'vue';
import type { Field } from '@ilteducation/content-search';

const useMaterialFilterFields = (): ComputedRef<Field[]> =>
  computed(() => [
    {
      aggregate: true,
      aggregationKey: 'language',
      label: 'label_language',
      type: 'list',
      item_label_prefix: 'languages',
    },
    {
      aggregate: true,
      aggregationKey: 'categories',
      kind: 'subject',
      label: 'label_subjects',
      type: 'list',
    },
    {
      aggregate: true,
      aggregationKey: 'areas',
      label: 'label_areas',
      type: 'list',
    },
    {
      aggregate: true,
      aggregationKey: 'keywords',
      label: 'label_keywords',
      type: 'list',
    },
    {
      aggregate: true,
      aggregationKey: 'properties.audiences',
      label: 'label_audience',
      type: 'list',
    },
    {
      aggregate: true,
      aggregationKey: 'categories',
      kind: 'grade',
      label: 'label_grades',
      type: 'list',
    },
  ]);

export default useMaterialFilterFields;
